var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(29.721 0.279) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 30,
    height: 30,
    transform: "translate(-0.279 -0.279)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(6.134 6.134)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x2: 17.174,
    transform: "translate(0 8.587)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10,4.167l8.587,8.587L10,21.34",
    transform: "translate(-1.413 -4.167)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.f7d8d197c0d00f35f63ac44ddf3d1bf4.svg";
export { ForwardRef as ReactComponent };